<script lang="ts">
import { computed } from "vue";

export default {
  name: "InputDate",
  components: {},
  props: {
    inputType: String,
    name: String,
    format: String,
    from: Date,
    modelValue: Object,
    isSimpleValue: Boolean,
  },
  emits: ["update:dateValue", "update:sizeHeight"],
  setup(props, ctx) {
    const valueDate = computed(() => props.from || null);

    function updateValueDate(event: unknown) {
      if (typeof event === "number") {
        ctx.emit("update:sizeHeight", event);
      }
      ctx.emit("update:dateValue", {
        value: valueDate.value,
        filter: valueDate.value ? new Date(valueDate.value).getTime() : null,
        componentKey: props.name,
        isSimpleValue: props.isSimpleValue,
        name: props.name,
      });
    }
    return {
      valueDate,
      updateValueDate,
    };
  },
};
</script>

<template>
  <div
    v-if="inputType === 'datetime'"
    class="row"
  >
    <b-datetimepicker
      v-model="valueDate"
      aria-hidden="false"
      :placeholder="$t('dataTypesRepository.placeholder-datepicker') + format"
      editable
      expanded
      icon="calendar-day"
      :years-range="[-100, 100]"
      @focus="updateValueDate(22.625)"
      @blur="updateValueDate(-22.625)"
    />
  </div>
  <div
    v-else-if="inputType === 'date'"
    class="row"
  >
    <b-datepicker
      v-model="valueDate"
      aria-hidden="false"
      :placeholder="$t('dataTypesRepository.placeholder-datepicker') + format"
      editable
      expanded
      icon="calendar-day"
      :years-range="[-100, 100]"
      @focus="updateValueDate(22.625)"
      @blur="updateValueDate(-22.625)"
    />
  </div>
  <div
    v-else-if="inputType === 'time'"
    class="row"
  >
    <b-timepicker
      v-model="valueDate"
      aria-hidden="false"
      :placeholder="$t('dataTypesRepository.placeholder-datepicker') + format"
      editable
      expanded
      icon="clock"
      :years-range="[-100, 100]"
      @blur="updateValueDate"
    />
  </div>
</template>
